/* eslint-disable camelcase */
export const localStorageKey = {
    viewArticleUid: 'viewArticleUid',
    referrer: 'listViewReferrer',
    feed: {
        listData: 'feedArticleList',
        clickArticleUid: 'feedClickArticleUid',
        lastTime: 'feedLastCreateTimeParam',
    },
    feed_magazine: {
        listData: 'feedMagazineList',
        clickArticleUid: 'feedClickMagazineUid',
        lastTime: 'feedMagazineLastCreateTimeParam',
    },
    feed_following: {
        listData: 'feedFollowingList',
        clickArticleUid: 'feedClickFollowingUid',
        lastTime: 'feedFollowingListLastCreateTimeParam',
    },
    home: {
        listData: 'homeArticleList',
        clickArticleUid: 'homeClickArticleUid',
        lastTime: 'homeLastCreateTimeParam',
    },
    home_image: {
        listData: 'homeArticleImageTypeList',
        clickArticleUid: 'homeClickArticleImageTypeUid',
        lastTime: 'homeImageTypeLastCreateTimeParam',
    },
    magazine: {
        listData: 'magazineArticleList',
        clickArticleUid: 'magazineClickArticleUid',
        lastTime: 'magazineLastCreateTimeParam',
    },
    now: {
        listData: 'nowArticleList',
        clickArticleUid: 'nowClickArticleUid',
        lastTime: 'nowLastCreateTimeParam',
    },
    likeit: {
        article: {
            listData: 'likeitArticleList2',
            lastTime: 'likeitArticleLastCreateTimeParam2',
            clickUid: 'likeitArticleClickUid2',
            moreList: 'likeitArticleMoreList2',
        },
        magazine: {
            listData: 'likeitMagazineList2',
            lastTime: 'likeitMagazineLastCreateTimeParam2',
            clickUid: 'likeitMagazineClickUid2',
            moreList: 'likeitMagazineMoreList2',
        },
    },
    pod: {
        visit: 'pod_visit',
    },
    search: {
        queries: 'searchQueries',
    },
    brunchbook: {
        lastViewArticle: {
            listData: 'lastViewArticleForBrunchbook',
        },
    },
};
